import { forwardRef, type SVGProps } from 'react';

export interface ProportionsIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const ProportionsIcon = forwardRef<SVGSVGElement, ProportionsIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M10.9502 7.1665C10.9502 6.95885 10.8675 6.75965 10.7207 6.61279C10.5738 6.46589 10.3743 6.3833 10.1665 6.3833H8.7168V12.6167H10.9502V7.1665ZM2.0498 11.8335C2.04989 12.266 2.40093 12.6167 2.8335 12.6167H7.6167V6.3833H2.0498V11.8335ZM12.0498 12.6167H13.5C13.9326 12.6167 14.2831 12.266 14.2832 11.8335V3.8335C14.2832 3.40087 13.9326 3.0498 13.5 3.0498H2.8335C2.40087 3.0498 2.0498 3.40087 2.0498 3.8335V5.2832H10.1665C10.666 5.2832 11.1453 5.48177 11.4985 5.83496C11.8516 6.18811 12.0498 6.66711 12.0498 7.1665V12.6167ZM15.3833 11.8335C15.3832 12.8736 14.5401 13.7168 13.5 13.7168H2.8335C1.79341 13.7168 0.950283 12.8736 0.950195 11.8335V3.8335C0.950195 2.79336 1.79336 1.9502 2.8335 1.9502H13.5C14.5401 1.9502 15.3833 2.79336 15.3833 3.8335V11.8335Z"
      fill="currentColor"
    />
  </svg>
));

ProportionsIcon.displayName = 'ProportionsIcon';
